import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Box, Divider, LinearProgress, ListItem, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from '@material-ui/core';
import { Folder as FolderIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { formatDate, formatSize } from '@sierralabs/core';
import { useFindFileLogs } from '../hooks/useFindFileLogs';
import DocumentUserLink from './DocumentUserLink';
const StyledTabPanel = styled.div `
  flex: 1;
  overflow-y: auto;
`;
const StyledTableContainer = styled(TableContainer) `
  thead {
    text-transform: uppercase;
  }
`;
const StyledList = styled(Box) `
  font-size: 13px;
  margin-top: 10px;
  .location-path {
    margin-left: 30px;
    margin-top: 3px;
  }
  li {
    line-height: 2em;
    div:nth-child(1) {
      flex: 2;
      font-weight: 300;
    }
    div:nth-child(2) {
      flex: 3;
    }
  }
`;
const DocumentInfoDrawerTabPanel = props => {
    var _a;
    const { file } = props;
    const [index, setIndex] = useState(0);
    const { data, isLoading, error, get } = useFindFileLogs(file.id);
    const logs = (data === null || data === void 0 ? void 0 : data.data) || [];
    useEffect(() => {
        setIndex(0);
        get();
    }, [get]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, { value: index, scrollButtons: 'auto', indicatorColor: 'primary', onChange: (_, value) => setIndex(value) }, ['Details', 'History'].map((label, index) => (React.createElement(Tab, { key: index, label: label, id: `tab-${index}`, "aria-controls": `tabpanel-${index}` })))),
        React.createElement(Divider, null),
        React.createElement(TabPanel, { index: 0, value: index },
            React.createElement(StyledList, null,
                !file.isFolder && (React.createElement(ListItem, null,
                    React.createElement(Box, null, "ID"),
                    React.createElement(Box, null, ((_a = file.task) === null || _a === void 0 ? void 0 : _a.key) || `DOC-${file.id}`))),
                React.createElement(ListItem, null,
                    React.createElement(Box, null, "Type"),
                    React.createElement(Box, null, file.isFolder ? 'Folder' : 'File')),
                React.createElement(ListItem, null,
                    React.createElement(Box, null, "Size"),
                    React.createElement(Box, null, formatSize(file.size || 0))),
                React.createElement(ListItem, null,
                    React.createElement(Box, null, "Location"),
                    React.createElement(Box, null,
                        React.createElement("div", { style: { float: 'left' } },
                            React.createElement(FolderIcon, null)),
                        React.createElement("div", { className: 'location-path' }, file.path))),
                React.createElement(ListItem, null,
                    React.createElement(Box, null, "Owner"),
                    React.createElement(Box, null,
                        React.createElement(DocumentUserLink, { user: file.ownedBy }))),
                React.createElement(ListItem, null,
                    React.createElement(Box, null, "Modified"),
                    React.createElement(Box, null,
                        formatDate(file.modified),
                        ' ',
                        file.modifiedBy && (React.createElement(React.Fragment, null,
                            "by ",
                            React.createElement(DocumentUserLink, { user: file.modifiedBy }))))),
                React.createElement(ListItem, null,
                    React.createElement(Box, null, "Created"),
                    React.createElement(Box, null,
                        formatDate(file.created),
                        ' ',
                        file.createdBy && (React.createElement(React.Fragment, null,
                            "by ",
                            React.createElement(DocumentUserLink, { user: file.createdBy }))))))),
        React.createElement(TabPanel, { index: 1, value: index },
            React.createElement(StyledTableContainer, null,
                React.createElement(Table, { stickyHeader: true },
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, "History"),
                            React.createElement(TableCell, null, "Name"),
                            React.createElement(TableCell, null, "Date"))),
                    React.createElement(TableBody, null,
                        isLoading && (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 3, padding: 'none' },
                                React.createElement(LinearProgress, null)))),
                        error && (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 3, padding: 'none' },
                                React.createElement(Alert, { severity: 'error' }, (error === null || error === void 0 ? void 0 : error.message) ||
                                    'An error occurred while loading history.')))),
                        logs.length === 0 && (React.createElement(TableRow, null,
                            React.createElement(TableCell, { colSpan: 3 }, isLoading ? 'Loading history...' : 'No history.'))),
                        logs.map(log => (React.createElement(TableRow, { key: log.id },
                            React.createElement(TableCell, null, log.log),
                            React.createElement(TableCell, null,
                                React.createElement(DocumentUserLink, { user: file.createdBy })),
                            React.createElement(TableCell, null, formatDate(log.created)))))))))));
};
export default DocumentInfoDrawerTabPanel;
const TabPanel = props => {
    const { value, index, children } = props;
    return (React.createElement(StyledTabPanel, { role: 'tabpanel', hidden: value !== index, id: `tabpanel-${index}`, "aria-labelledby": `tab-${index}` }, value === index && React.createElement(Box, null, children)));
};
//# sourceMappingURL=DocumentInfoDrawerTabPanel.js.map